module.exports = __webpack_public_path__ + "static/media/finca.b523c7bf.png";